{
  "cycle.entite.depot_actualisations": "Repository refreshes",
  "v6.depot.choisir": "— Choose —",
  "v6.depot.code.ACCESS_DENIED": "You must be an active member of the project for this action.",
  "v6.depot.code.DROIT_NON_TENU": "You do not hold the right needed to read this project’s repository.",
  "v6.depot.code.IDEMPOTENCY_CONFLICT": "A repository refresh is already running for this project.",
  "v6.depot.code.SCM_NOT_CONFIGURED": "This project’s repository is not connected: a project administrator must register its GitLab connection.",
  "v6.depot.code.SCM_NOT_FOUND": "This reference or pipeline is unknown to the repository.",
  "v6.depot.code.SCM_UNAVAILABLE": "The repository tool cannot be reached right now.",
  "v6.depot.code.VALIDATION_ERROR": "Unreadable reference or identifier.",
  "v6.depot.environnement.libelle": "Environment concerned",
  "v6.depot.environnement.vide": "This project has declared no environment.",
  "v6.depot.etapes.titre": "Pipeline steps",
  "v6.depot.etapes.trace": "View trace",
  "v6.depot.etapes.trace_de": "View the trace of step {{etape}}",
  "v6.depot.etapes.vide": "This pipeline has no step.",
  "v6.depot.etat.chargement": "Loading {{quoi}}…",
  "v6.depot.etat.erreur": "Could not read {{quoi}}.",
  "v6.depot.etat.introuvable": "{{quoi}}: not found.",
  "v6.depot.etat.reessayer": "Retry",
  "v6.depot.etat.refus": "You cannot read {{quoi}}.",
  "v6.depot.pipeline.absent": "No pipeline is designated: open this page from the delivery cockpit.",
  "v6.depot.pipeline.identifiant": "Identifier",
  "v6.depot.pipeline.libelle": "the pipeline",
  "v6.depot.pipeline.panneau": "Pipeline",
  "v6.depot.pipeline.reference": "Reference",
  "v6.depot.pipeline.resume": "Pipeline #{{id}} · {{statut}} · {{commit}}",
  "v6.depot.pipeline.titre": "Delivery pipeline",
  "v6.depot.reference.absente": "No reference is designated: open this page from the delivery cockpit.",
  "v6.depot.reference.aucun_pipeline": "No pipeline on this commit.",
  "v6.depot.reference.auteur": "Author",
  "v6.depot.reference.auteur_inconnu": "not provided by the tool",
  "v6.depot.reference.commit": "Commit",
  "v6.depot.reference.libelle": "the repository reference",
  "v6.depot.reference.nature": "Kind",
  "v6.depot.reference.nature.branche": "Branch",
  "v6.depot.reference.nom": "Name",
  "v6.depot.reference.pipelines": "Commit pipelines",
  "v6.depot.reference.statut": "Status",
  "v6.depot.reference.statut.active": "active",
  "v6.depot.reference.statut.fusionnee": "merged",
  "v6.depot.reference.statut.protegee": "protected",
  "v6.depot.reference.titre": "Repository reference",
  "v6.depot.retour_cockpit": "Back to the delivery cockpit",
  "v6.depot.sans_projet": "No project is selected: open this screen from a project.",
  "v6.depot.statut.annule": "canceled",
  "v6.depot.statut.echoue": "failed",
  "v6.depot.statut.en_cours": "running",
  "v6.depot.statut.termine": "succeeded",
  "v6.depot.vague_ulterieure": "“{{ecran}}” leads to a screen that is not built yet: it comes with a later package of wave V6.",
  "v6.depot.versions.champ": "Version concerned",
  "v6.depot.versions.cible_incomplete": "Choose the version and the environment to open the version.",
  "v6.depot.versions.exacte": "Version matched by its exact commit.",
  "v6.depot.versions.identifiant": "Version {{id}}, commit {{commit}}",
  "v6.depot.versions.ouvrir": "Open the version",
  "v6.depot.versions.plusieurs": "Several versions carry this commit: choose the one to open.",
  "v6.depot.versions.titre": "Versions concerned",
  "v6.depot.versions.vide": "No project version carries this pipeline’s commit."
}
